<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0547 4.93506L6.80469 13.1851L3.05469 9.43506"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: '19',
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>
